export default Object.freeze({
  ObjectedByPurchasedEquipment: 1,
  ObjectedWithAppointment: 2,
  ObjectedNoPassing30Days: 6,
  ApprovedByUnitDirector: 5,
  ObjectedByUnitDirector: 7,
  ObjectedNoDiscussedCOMPU: 11,
  ObjectedDueLackReferral: 12,
  ObjectedByGeneral: 13,
  ApprovedByGeneral: 14,
  ApprovedByJudgeOrder: 15,
  ObjectionByNonAvailability: 16,
  ApprovedByReconsideration: 18,
  ExpirationService: 20,
  ObjectedByReferredActiveAgencySAEE: 21,
  Others: 22,
  ObjectedStudentUnilateralLocation: 23,
  High: 24,
  Egress: 25,
  RejectOfCompensatoryServices: 26,
  RejectToReceiveServiceWithSAEE: 27,
  DuplicateService: 28,
  TransferByOffering: 29,
  ThereAuthorizedPositionBySAEE: 36,
  IrregularStaffApplicationProcess: 38,
  ApprovedByCompensatoryServices: 30,
  ReturnedToSAEEByHiringLack: 41,
  RefusalOfParentsService: 42,
  ServiceHasAlreadyBeenProvided: 43,
});
